<script setup lang="ts">
import { Product } from "~/utils/Product";

const props = defineProps<{ product: Product, skeleton?:Boolean}>();

</script>

<template>
  <NuxtLink :to="'/shop/product/' + product.slug" class="related-product min-w-[100px] max-w-[100px] lg:min-w-[200px] lg:max-w-[200px]">
    <div class="mb-2">
      <NuxtImg 
        provider="strapi" 
        format="webp" 
        class="relatedProductImageContainer w-full h-[100px] lg:h-[200px] m-0"
        :class="{imageCover:!product.transparentImage}" 
        :src="product.images[0]?.rel_url" 
        loading="lazy" 
        :alt="product.images[0]?.alt || product.Name"/>
    </div>
    <div>
      <div class="text-sm lg:text-lg">{{ product.Name }}</div>
    </div>
  </NuxtLink>
</template>
<style scoped lang="scss">

 .relatedProductImageContainer {
    background:$imgBackground;
    border-radius: $public-radius-card;
    width:100%;
    height:100%;
    object-fit: contain;
    &.imageCover {
      background:none;
    }
  }

 .related-product{
   color: inherit;
   text-decoration: none;

   &:focus-visible{
     outline: 2px solid $public-focus;
     outline-offset: 4px;
   }
 }
</style>
